import { render, staticRenderFns } from "./referInfo.vue?vue&type=template&id=2ca3807e&scoped=true&"
import script from "./referInfo.vue?vue&type=script&lang=js&"
export * from "./referInfo.vue?vue&type=script&lang=js&"
import style0 from "./referInfo.vue?vue&type=style&index=0&id=2ca3807e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca3807e",
  null
  
)

export default component.exports